export const dashboardData = [
    {
      id: '1',
      type: 'email',
      direction: 'IN',
      name: 'Email Skill',
      campaign: 'Default',
      disposition: true,
      autowrap: true,
      sla: '30/90%',
      status: 'Active',
    },
    {
      id: '2',
      type: 'phone',
      direction: 'IN',
      name: 'Phone Skill',
      campaign: 'Default',
      disposition: true,
      autowrap: false,
      sla: '30/90%',
      status: 'Active',
    },
    {
      id: '3',
      type: 'phone',
      direction: 'OUT',
      name: 'Phone Skill',
      campaign: 'Default',
      disposition: false,
      autowrap: true,
      sla: '30/90%',
      status: 'Active',
    },
    {
      id: '4',
      type: 'phone',
      direction: 'IN',
      name: 'Phone Skill',
      campaign: 'Default',
      disposition: false,
      autowrap: true,
      sla: '30/90%',
      status: 'Active',
    },
    {
      id: '5',
      type: 'email',
      direction: 'IN',
      name: 'Email Skill',
      campaign: 'Default',
      disposition: true,
      autowrap: false,
      sla: '30/90%',
      status: 'Active',
    },
    {
      id: '6',
      type: 'email',
      direction: 'IN',
      name: 'Email Skill',
      campaign: 'Default',
      disposition: false,
      autowrap: true,
      sla: '30/90%',
      status: 'Active',
    },
    {
      id: '7',
      type: 'phone',
      direction: 'IN',
      name: 'Phone Skill',
      campaign: 'Default',
      disposition: true,
      autowrap: false,
      sla: '30/90%',
      status: 'Active',
    },
    {
      id: '8',
      type: 'workitem',
      direction: 'OUT',
      name: 'Work Item Skill',
      campaign: 'Default',
      disposition: true,
      autowrap: true,
      sla: '30/90%',
      status: 'Active',
    },
    {
      id: '9',
      type: 'phone',
      direction: 'IN',
      name: 'Phone Skill',
      campaign: 'Default',
      disposition: true,
      autowrap: true,
      sla: '30/90%',
      status: 'Active',
    },
    {
      id: '10',
      type: 'chat',
      direction: 'IN',
      name: 'Chat Skill',
      campaign: 'Default',
      disposition: true,
      autowrap: true,
      sla: '30/90%',
      status: 'Active',
    },
    {
      id: '11',
      type: 'phone',
      direction: 'OUT',
      name: 'Phone Skill',
      campaign: 'Default',
      disposition: false,
      autowrap: false,
      sla: '30/90%',
      status: 'Active',
    },
    {
      id: '12',
      type: 'voicemail',
      direction: 'IN',
      name: 'Voicemail Skill',
      campaign: 'Default',
      disposition: true,
      autowrap: true,
      sla: '30/90%',
      status: 'Active',
    },
    {
      id: '13',
      type: 'phone',
      direction: 'IN',
      name: 'Phone Skill',
      campaign: 'Default',
      disposition: true,
      autowrap: true,
      sla: '30/90%',
      status: 'Active',
    },
    {
      id: '14',
      type: 'chat',
      direction: 'IN',
      name: 'Chat Skill',
      campaign: 'Default',
      disposition: true,
      autowrap: false,
      sla: '30/90%',
      status: 'Active',
    },
    {
      id: '15',
      type: 'phone',
      direction: 'OUT',
      name: 'Phone Skill',
      campaign: 'Default',
      disposition: true,
      autowrap: true,
      sla: '30/90%',
      status: 'Active',
    },
    {
      id: '16',
      type: 'phone',
      direction: 'OUT',
      name: 'Phone Skill',
      campaign: 'Default',
      disposition: false,
      autowrap: true,
      sla: '30/90%',
      status: 'Active',
    },
    {
      id: '16',
      type: 'email',
      direction: 'IN',
      name: 'Email Skill',
      campaign: 'Default',
      disposition: true,
      autowrap: true,
      sla: '30/90%',
      status: 'Active',
    },
  ];
  